export function fetchDailyTexts(user_id) {
  return fetch(
    `${process.env.REACT_APP_DTDATA_URI}/dts/findHoursAndDays/${user_id}`
  )
    .then(res => res.json())
    .then(payload => {
      if (!payload) throw new Error("No dts found");
      return payload;
    });
}

export function updateDailyTexts({ user_id, hours = [], days = [] }) {
  return fetch(
    `${process.env.REACT_APP_DTDATA_URI}/dts/saveHoursAndDays/${user_id}`,
    {
      method: "POST",
      body: JSON.stringify({ hours, days })
    }
  ).then(res => res.json());
}

export default {
  fetchDailyTexts,
  updateDailyTexts
};



// WEBPACK FOOTER //
// ./src/api/dts/index.js